import React from "react";

// import { Container } from './styles';

const StockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.604"
    height="18.45"
    viewBox="0 0 18.604 18.45"
  >
    <g id="Estoque" transform="translate(-24.293 -326.293)">
      <rect
        id="Retângulo_558"
        data-name="Retângulo 558"
        width="13.336"
        height="13.336"
        transform="translate(25 330.7)"
        strokeWidth="1"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        id="Caminho_593"
        data-name="Caminho 593"
        d="M5.5.5H18.836V13.836"
        transform="translate(23.354 326.5)"
        fill="none"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <line
        id="Linha_50"
        data-name="Linha 50"
        y1="3.7"
        x2="3.854"
        transform="translate(38.336 327)"
        fill="none"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <line
        id="Linha_51"
        data-name="Linha 51"
        y1="3.7"
        x2="3.854"
        transform="translate(25 327)"
        fill="none"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <line
        id="Linha_52"
        data-name="Linha 52"
        y1="3.7"
        x2="3.854"
        transform="translate(38.336 340.336)"
        fill="none"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <g
        id="Agrupar_330"
        data-name="Agrupar 330"
        transform="translate(29.548 327)"
      >
        <path
          id="Caminho_594"
          data-name="Caminho 594"
          d="M6.4,17.536V4.2L10.331.5"
          transform="translate(-6.4 -0.5)"
          fill="none"
          stroke="#383838"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
        <path
          id="Caminho_595"
          data-name="Caminho 595"
          d="M11.9,17.536V4.2L15.908.5"
          transform="translate(-7.66 -0.5)"
          fill="none"
          stroke="#383838"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
);
export default StockIcon;
